export enum Metrics {
    SUBMIT = 'submit',
    RESPONSE_TIME = 'APIResponseTime',
    REQUESTS = 'requests',
}
